export default [
  {
    path: 'organization/:id',
    name: 'organization',
    component: () => import('@/views/pages/organization/View.vue'),
    meta: {
      pageTitle: 'Organization',
      breadcrumb: [
        {
          to: { name: 'organizations' },
          text: 'Organizations',
          active: false,
        },
        {
          text: 'Organization',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
